/* eslint-disable max-len */
import React from 'react';

export const DiscordIconHeader = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="#fff"
      d="M18.93 5.642a16.491 16.491 0 0 0-4.07-1.263.062.062 0 0 0-.066.03c-.175.314-.37.722-.506 1.042a15.226 15.226 0 0 0-4.573 0A10.538 10.538 0 0 0 9.2 4.41a.064.064 0 0 0-.065-.031 16.447 16.447 0 0 0-4.07 1.263.058.058 0 0 0-.028.023c-2.593 3.873-3.303 7.652-2.954 11.383a.069.069 0 0 0 .026.047 16.586 16.586 0 0 0 4.994 2.525.065.065 0 0 0 .07-.024c.385-.525.728-1.079 1.022-1.661a.063.063 0 0 0-.035-.088 10.917 10.917 0 0 1-1.56-.744.064.064 0 0 1-.007-.106c.105-.079.21-.16.31-.243a.062.062 0 0 1 .065-.009c3.273 1.494 6.817 1.494 10.051 0a.062.062 0 0 1 .066.008c.1.083.204.165.31.244a.064.064 0 0 1-.005.106c-.499.291-1.017.537-1.561.743a.064.064 0 0 0-.034.089 13.3 13.3 0 0 0 1.02 1.66.063.063 0 0 0 .07.025 16.532 16.532 0 0 0 5.003-2.525.065.065 0 0 0 .026-.046c.417-4.314-.699-8.062-2.957-11.384a.05.05 0 0 0-.026-.023ZM8.684 14.776c-.985 0-1.797-.905-1.797-2.016 0-1.11.796-2.015 1.797-2.015 1.01 0 1.813.912 1.798 2.015 0 1.111-.796 2.016-1.798 2.016Zm6.646 0c-.986 0-1.797-.905-1.797-2.016 0-1.11.796-2.015 1.797-2.015 1.009 0 1.813.912 1.797 2.015 0 1.111-.788 2.016-1.797 2.016Z"
    />
  </svg>
);

export const TelegramIconHeader = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="#fff"
      d="M19.783 3.679 4.39 12.558a.798.798 0 0 0 .073 1.435l3.53 1.48 9.54-8.407c.183-.163.442.086.286.275l-8 9.746v2.674c0 .783.947 1.092 1.412.524l2.109-2.567 4.137 1.734a.8.8 0 0 0 1.096-.605l2.39-14.345a.797.797 0 0 0-1.181-.823Z"
    />
  </svg>
);

export const TwitterIconHeader = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="#fff"
      d="M5.577 5.42h.225c1.14 0 2.28.001 3.42-.003.135 0 .216.04.293.155 1.061 1.555 2.129 3.107 3.212 4.683.168-.192.329-.376.486-.56 1.185-1.378 2.371-2.755 3.552-4.136a.351.351 0 0 1 .308-.14c.3.008.599.002.943.002-.214.252-.398.47-.583.686-1.351 1.57-2.702 3.143-4.057 4.71-.109.126-.126.208-.025.354 1.659 2.406 3.312 4.817 4.967 7.227.033.047.064.098.109.169-.07.006-.119.014-.168.014-1.14 0-2.281-.004-3.421.003-.166.002-.263-.05-.359-.19-1.098-1.612-2.203-3.22-3.308-4.828-.019-.027-.042-.052-.074-.09l-.778.902c-1.163 1.352-2.327 2.705-3.486 4.06a.377.377 0 0 1-.327.148c-.292-.01-.586-.003-.931-.003l5.025-5.845L5.578 5.42Zm11.31 12.341c-.057-.085-.09-.134-.125-.183l-3.524-5.047c-1.43-2.046-2.857-4.09-4.29-6.13a.341.341 0 0 0-.24-.125c-.469-.011-.94-.006-1.41-.004-.048 0-.098.007-.167.013l.1.152 3.537 5.061c1.424 2.04 2.849 4.078 4.277 6.114.044.064.127.14.194.14.536.015 1.071.01 1.648.01Z"
    />
  </svg>
);

export const YoutubeIconHeader = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="#fff"
      d="m10 15 5.19-3L10 9v6Zm11.56-7.83c.13.47.22 1.1.28 1.9.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83-.25.9-.83 1.48-1.73 1.73-.47.13-1.33.22-2.65.28-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44-.9-.25-1.48-.83-1.73-1.73-.13-.47-.22-1.1-.28-1.9-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83.25-.9.83-1.48 1.73-1.73.47-.13 1.33-.22 2.65-.28 1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44.9.25 1.48.83 1.73 1.73Z"
    />
  </svg>
);

export const MediumIconHeader = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <g fill="#fff" clipPath="url(#a)">
      <path d="M13.562 12c-.008 3.748-3.047 6.785-6.787 6.78A6.788 6.788 0 0 1 0 11.968C.015 8.23 3.058 5.2 6.786 5.208c3.748.008 6.784 3.052 6.777 6.791ZM20.943 12.126c-.018 1.424-.262 2.934-.983 4.336-.271.529-.61 1.01-1.07 1.395-.931.775-2.015.76-2.927-.044-.663-.586-1.093-1.331-1.374-2.153-.912-2.674-.883-5.328.25-7.937a4.275 4.275 0 0 1 1.2-1.629c.905-.745 1.97-.737 2.86.03.729.625 1.156 1.446 1.472 2.331.408 1.143.567 2.329.572 3.672ZM21.52 12.002c.016-1.474.09-2.942.442-4.381.058-.235.134-.467.22-.694.056-.148.131-.292.22-.422.234-.34.494-.34.723 0 .281.416.396.898.503 1.379.226 1.013.32 2.043.357 3.077.06 1.669.01 3.333-.322 4.976-.09.445-.243.88-.398 1.31-.083.23-.206.492-.5.494-.298 0-.403-.27-.507-.493-.283-.603-.427-1.25-.498-1.905-.12-1.11-.2-2.223-.297-3.336l.058-.005Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowUpRightIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1283 8.45709L5.63597 16.9494L7.05018 18.3637L15.5425 9.87131L17.6639 11.9926L17.6568 6.34284L12.007 6.33577L14.1283 8.45709Z"
      fill="white"
    />
  </svg>
);

export const DocumentsIcon = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5527 2.5C11.8239 2.5 12.0841 2.61182 12.2712 2.80875L15.4378 6.20104C15.612 6.3851 15.709 6.62953 15.709 6.88286V15.3646C15.709 15.627 15.6047 15.8787 15.4191 16.0643C15.2336 16.2499 14.9819 16.3542 14.7194 16.3542H4.82357C4.56111 16.3542 4.30941 16.2499 4.12383 16.0643C3.93824 15.8787 3.83398 15.627 3.83398 15.3646V3.48958C3.83398 3.22713 3.93824 2.97543 4.12383 2.78984C4.30941 2.60426 4.56111 2.5 4.82357 2.5H11.5527ZM14.7194 7.44792H11.2559C11.1246 7.44792 10.9988 7.39579 10.906 7.303C10.8132 7.2102 10.7611 7.08435 10.7611 6.95312V3.48958H4.82357V15.3646H14.7194V7.44792ZM7.29753 13.3854C7.1663 13.3854 7.04045 13.3333 6.94766 13.2405C6.85486 13.1477 6.80273 13.0219 6.80273 12.8906C6.80273 12.7594 6.85486 12.6335 6.94766 12.5408C7.04045 12.448 7.1663 12.3958 7.29753 12.3958H12.2454C12.3767 12.3958 12.5025 12.448 12.5953 12.5408C12.6881 12.6335 12.7402 12.7594 12.7402 12.8906C12.7402 13.0219 12.6881 13.1477 12.5953 13.2405C12.5025 13.3333 12.3767 13.3854 12.2454 13.3854H7.29753ZM7.29753 10.4167C7.1663 10.4167 7.04045 10.3645 6.94766 10.2717C6.85486 10.179 6.80273 10.0531 6.80273 9.92188C6.80273 9.79065 6.85486 9.6648 6.94766 9.572C7.04045 9.47921 7.1663 9.42708 7.29753 9.42708H12.2454C12.3767 9.42708 12.5025 9.47921 12.5953 9.572C12.6881 9.6648 12.7402 9.79065 12.7402 9.92188C12.7402 10.0531 12.6881 10.179 12.5953 10.2717C12.5025 10.3645 12.3767 10.4167 12.2454 10.4167H7.29753ZM8.28711 18.3333C8.15588 18.3333 8.03003 18.2812 7.93724 18.1884C7.84445 18.0956 7.79232 17.9698 7.79232 17.8385C7.79232 17.7073 7.84445 17.5815 7.93724 17.4887C8.03003 17.3959 8.15588 17.3438 8.28711 17.3438H16.6986V8.93229C16.6986 8.80106 16.7507 8.67521 16.8435 8.58242C16.9363 8.48963 17.0621 8.4375 17.1934 8.4375C17.3246 8.4375 17.4504 8.48963 17.5432 8.58242C17.636 8.67521 17.6882 8.80106 17.6882 8.93229V17.3438C17.6882 17.6062 17.5839 17.8579 17.3983 18.0435C17.2127 18.2291 16.961 18.3333 16.6986 18.3333H8.28711Z"
      fill="white"
    />
  </svg>
);

export const EducationIcon = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1686 17.5L4.33529 14.3333V9.33333L1.00195 7.5L10.1686 2.5L19.3353 7.5V14.1667H17.6686V8.41667L16.002 9.33333V14.3333L10.1686 17.5ZM10.1686 10.5833L15.877 7.5L10.1686 4.41667L4.46029 7.5L10.1686 10.5833ZM10.1686 15.6042L14.3353 13.3542V10.2083L10.1686 12.5L6.00195 10.2083V13.3542L10.1686 15.6042Z"
      fill="white"
    />
  </svg>
);
